import {createContext} from 'react';
import {Main} from 'app/components/entities/cloud/model';

export const FeaturesContext = createContext<Set<Main.Feature>>(new Set());
